"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import FocusLock from 'react-focus-lock';
import { useComboBox } from '../context/combobox-context.mjs';

const TRAP_GROUP = "combobox-dropdown";
function DropdownFocusTrap({ children }) {
  const { isDropdownOpen, scopedComboboxId } = useComboBox();
  return /* @__PURE__ */ jsx(FocusLock, { group: TRAP_GROUP + scopedComboboxId, disabled: !isDropdownOpen, returnFocus: true, autoFocus: false, as: "span", children });
}

export { DropdownFocusTrap };
